<template>
  <!-- pdf 上传压缩地址 : https://smallpdf.com/cn/compress-pdf -->
  <d2-container id="page">
    <el-row style="padding-top:40px;">
      <el-col :span="2"><div class="grid-content bg-purple">&nbsp;</div></el-col>
      <el-col :span="20">
        <el-row style="margin:0 0 10px;">
          <el-col :span="5" style="display: flex;justify-content: center;align-items: center;cursor:pointer;">
            <svg t="1629886551517" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6226" width="64" height="64"><path d="M851.593342 894.529826l-148.784333-36.294038L612.180036 981.55062l-174.041588-478.614366 239.20106-87.23304L851.593342 894.529826z" fill="#1296db" p-id="6227"></path><path d="M612.180036 1023.999788h-5.942884a42.449168 42.449168 0 0 1-33.959334-27.591959l-174.041588-478.614367a42.449168 42.449168 0 0 1 25.257255-54.334934l239.413306-87.23304a42.449168 42.449168 0 0 1 32.473614 1.485721 42.449168 42.449168 0 0 1 21.224584 23.98378l174.253833 478.614366a42.449168 42.449168 0 0 1-49.877772 55.820656l-121.192374-29.502172-73.861552 100.392282a42.449168 42.449168 0 0 1-33.747088 16.979667z m-119.706653-495.806279l132.441403 364.213859 43.722643-59.428835a42.449168 42.449168 0 0 1 44.35938-15.918438l71.526848 17.404159-132.441403-364.213859z" fill="#1296db" p-id="6228"></path><path d="M172.406658 894.529826l148.784333-36.294038L411.819964 981.55062l174.041588-478.614366-239.20106-87.23304L172.406658 894.529826z" fill="#1296db" p-id="6229"></path><path d="M411.819964 1023.999788a42.449168 42.449168 0 0 1-34.383826-17.404159l-73.861552-100.392282-121.192374 29.502172a42.449168 42.449168 0 0 1-49.877772-55.820656l174.253834-478.614366a42.449168 42.449168 0 0 1 21.224584-23.98378 42.449168 42.449168 0 0 1 32.473613-1.485721l239.413306 87.23304a42.449168 42.449168 0 0 1 25.257255 54.334935l-174.041588 478.614366a42.449168 42.449168 0 0 1-33.959334 27.591959zM320.978745 815.78662a42.449168 42.449168 0 0 1 34.17158 17.191913l43.722643 59.428835 132.441403-364.213859-159.396625-57.943114-132.441403 364.213859 71.526848-17.404159a42.449168 42.449168 0 0 1 9.975554-1.273475z" fill="#1296db" p-id="6230"></path><path d="M812.964599 364.551967l35.020564-84.898336A47.755314 47.755314 0 0 0 822.09117 217.465601l-84.898335-35.020564a46.90633 46.90633 0 0 1-25.893992-25.893992l-34.808318-84.898336a47.96756 47.96756 0 0 0-63.673752-25.681746l-84.898335 34.808317a47.330822 47.330822 0 0 1-36.506284 0L409.48526 47.66893a47.96756 47.96756 0 0 0-63.673752 25.681746l-34.808317 84.898336a46.90633 46.90633 0 0 1-25.893993 25.893992L201.90883 217.465601a47.755314 47.755314 0 0 0-25.893993 63.673751l35.020564 84.898336a47.755314 47.755314 0 0 1 0 36.71853l-35.020564 84.898335a47.96756 47.96756 0 0 0 25.893993 62.400277l84.898335 34.808317a48.392051 48.392051 0 0 1 25.893992 25.893993l34.808318 84.898335a47.96756 47.96756 0 0 0 63.673752 25.893993l84.898335-34.808318a47.330822 47.330822 0 0 1 36.506284 0l84.898336 34.808318a47.96756 47.96756 0 0 0 63.673751-25.893993l34.808318-84.898335a48.392051 48.392051 0 0 1 25.893992-25.893993l84.898336-34.808317a47.96756 47.96756 0 0 0 25.893992-62.400277l-35.020563-84.898335a47.755314 47.755314 0 0 1-4.669409-38.204251z" fill="#1296db" p-id="6231" data-spm-anchor-id="a313x.7781069.0.i19" class=""></path><path d="M632.767882 764.847619a89.355498 89.355498 0 0 1-34.383826-6.791867l-84.898335-34.808318a4.881654 4.881654 0 0 0-4.244917 0l-84.898335 34.808318a90.204481 90.204481 0 0 1-117.796441-48.816543l-35.020563-84.898336a5.306146 5.306146 0 0 0-2.759196-2.971441l-84.898336-34.808318a90.628973 90.628973 0 0 1-49.028788-118.008686l35.020563-84.898336a6.579621 6.579621 0 0 0 0-4.032671l-35.020563-84.898335a90.841219 90.841219 0 0 1 0-69.192143 89.992236 89.992236 0 0 1 49.028788-48.816543l84.898336-34.808318a5.306146 5.306146 0 0 0 2.759196-2.971442l35.020563-84.898335A89.992236 89.992236 0 0 1 425.615944 7.766712l84.898335 34.808318a4.881654 4.881654 0 0 0 4.244917 0l84.898335-34.808318a89.992236 89.992236 0 0 1 117.796441 48.816543l35.020563 84.898335a5.306146 5.306146 0 0 0 2.759196 2.971442l84.898336 34.808318a89.992236 89.992236 0 0 1 49.028788 48.816543 90.841219 90.841219 0 0 1 0 69.192143L851.593342 380.894896a6.579621 6.579621 0 0 0 0 4.032671l35.020563 84.898336a90.628973 90.628973 0 0 1-48.816543 118.008686l-84.898335 34.808318a5.306146 5.306146 0 0 0-2.759196 2.971441l-35.020563 84.898336a90.204481 90.204481 0 0 1-82.351386 54.334935zM512 637.712361a89.992236 89.992236 0 0 1 34.596072 7.004113l84.898335 34.808318a5.306146 5.306146 0 0 0 7.004113-2.759196l34.808317-84.898336a89.567744 89.567744 0 0 1 48.816543-48.816543l84.898336-35.020563a5.306146 5.306146 0 0 0 2.971442-7.004113l-34.808318-84.898335a88.506515 88.506515 0 0 1 0-68.979898l34.808318-84.898335a4.881654 4.881654 0 0 0 0-4.244917 4.881654 4.881654 0 0 0-2.971442-2.759196l-84.898336-35.020563a91.690202 91.690202 0 0 1-48.816543-48.816543L637.861782 90.118097a5.518392 5.518392 0 0 0-7.004112-2.971441l-84.898336 35.020563a90.841219 90.841219 0 0 1-69.192143 0l-84.898336-35.020563a5.518392 5.518392 0 0 0-7.004112 2.971441l-34.808318 84.898336a91.690202 91.690202 0 0 1-48.816543 48.816543l-84.898335 35.020563A4.881654 4.881654 0 0 0 214.855826 259.914768a4.881654 4.881654 0 0 0 0 4.244917l34.808317 84.898336a88.506515 88.506515 0 0 1 0 68.979897l-34.808317 84.898336a5.306146 5.306146 0 0 0 2.971442 7.004112l84.898335 35.020564a89.567744 89.567744 0 0 1 48.816543 48.816543l34.808317 84.898335a5.306146 5.306146 0 0 0 7.004113 2.759196l84.898336-34.808317A89.992236 89.992236 0 0 1 512 637.712361z m300.964599-273.160394z" fill="#f4ea2a" p-id="6232" data-spm-anchor-id="a313x.7781069.0.i21" class="selected"></path><path d="M531.314371 266.706635l26.318484 45.42061a23.134796 23.134796 0 0 0 14.008226 10.400046l50.726755 12.946996a22.498059 22.498059 0 0 1 12.098013 35.869547l-35.020563 43.510397a21.224584 21.224584 0 0 0-4.881655 15.706192l3.820425 55.608409a22.285813 22.285813 0 0 1-31.200138 21.224584l-46.269593-20.163354a21.224584 21.224584 0 0 0-18.040896 0l-45.632855 20.163354a22.498059 22.498059 0 0 1-31.412385-21.224584l4.032671-56.457393a23.347042 23.347042 0 0 0-5.0939-15.706192l-35.020563-43.510397a22.285813 22.285813 0 0 1 11.885767-35.869546l50.939001-11.036784a23.134796 23.134796 0 0 0 14.008226-10.400046l26.106238-45.42061a22.285813 22.285813 0 0 1 38.628742-1.061229z" fill="#f4ea2a" p-id="6233" data-spm-anchor-id="a313x.7781069.0.i20" class="selected"></path></svg>
            <span style="margin-left:5px">企业认证：{{userStatus.auth?'已认证':'未认证'}} </span>
          </el-col>
          <el-col :span="5" style="display: flex;justify-content: center;align-items: center;cursor:pointer;">
            <svg t="1629886476273" class="icon" viewBox="0 0 1095 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4253" width="64" height="64"><path d="M297.984 128h512l85.504 149.504H212.992L297.984 128z" fill="#BBE2FF" p-id="4254"></path><path d="M297.984 213.504h512c47.104 0 85.504 38.4 85.504 85.504v512c0 47.104-38.4 85.504-85.504 85.504h-512c-47.104 0-85.504-38.4-85.504-85.504v-512c0.512-47.616 38.4-85.504 85.504-85.504z m128 139.776c-23.552 0-42.496 18.944-42.496 42.496 0 23.552 18.944 42.496 42.496 42.496h256c23.552 0 42.496-18.944 42.496-42.496 0-23.552-18.944-42.496-42.496-42.496h-256z" fill="#0091EB" p-id="4255"></path><path d="M553.984 570.88m-65.024 0a65.024 65.024 0 1 0 130.048 0 65.024 65.024 0 1 0-130.048 0Z" fill="#f4ea2a" p-id="4256" data-spm-anchor-id="a313x.7781069.0.i14" class="selected"></path></svg>
            <span style="margin-left:5px">&nbsp;&nbsp;资料提交：{{materialFinish?'已提交': userStatus.subMaterial+'/'+userStatus.totalMaterial}}</span>
          </el-col>
          <el-col :span="5" style="display: flex;justify-content: center;align-items: center;cursor:pointer;">
            <svg t="1629886623588" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7389" width="64" height="64"><path d="M778.24 163.84c-76.8-40.96-165.888-61.44-269.312-61.44s-192.512 20.48-269.312 61.44h-133.12l23.552 337.92c8.192 113.664 67.584 217.088 162.816 280.576l215.04 144.384 215.04-144.384c96.256-63.488 155.648-166.912 163.84-280.576l23.552-337.92H778.24z m47.104 333.824c-7.168 94.208-56.32 181.248-135.168 233.472l-181.248 120.832L327.68 731.136c-78.848-53.248-129.024-139.264-135.168-233.472L173.056 225.28h136.192v-26.624c58.368-23.552 124.928-34.816 199.68-34.816s141.312 12.288 199.68 34.816V225.28H844.8l-19.456 272.384z" fill="#1296db" p-id="7390"></path><path d="M685.056 328.704v-46.08H455.68c2.048-4.096 6.144-9.216 11.264-15.36 5.12-7.168 9.216-12.288 11.264-15.36L419.84 240.64c-31.744 46.08-75.776 87.04-133.12 123.904 4.096 4.096 10.24 11.264 18.432 21.504l17.408 17.408c23.552-15.36 45.056-31.744 63.488-50.176 26.624 25.6 49.152 43.008 67.584 51.2-46.08 15.36-104.448 27.648-175.104 35.84 2.048 5.12 6.144 13.312 9.216 24.576 4.096 11.264 6.144 19.456 7.168 24.576l39.936-7.168v218.112H389.12V680.96h238.592v19.456h54.272V481.28H348.16c60.416-12.288 114.688-27.648 163.84-46.08 49.152 19.456 118.784 34.816 210.944 46.08 5.12-17.408 10.24-34.816 17.408-51.2-62.464-4.096-116.736-12.288-161.792-24.576 38.912-20.48 74.752-46.08 106.496-76.8z m-150.528 194.56h94.208v41.984h-94.208v-41.984z m0 78.848h94.208v41.984h-94.208v-41.984z m-144.384-78.848h94.208v41.984H390.144v-41.984z m0 78.848h94.208v41.984H390.144v-41.984zM424.96 326.656h182.272c-26.624 22.528-57.344 41.984-94.208 57.344-31.744-15.36-61.44-34.816-88.064-57.344z" fill="#f4ea2a" p-id="7391" data-spm-anchor-id="a313x.7781069.0.i27" class="selected"></path></svg>
            <span style="margin-left:5px">&nbsp;&nbsp;备案状态：{{userStatus.record==true?'已备案':'未通过'}}</span>
          </el-col>
          <el-col :span="5" style="display: flex;justify-content: center;align-items: center;cursor:pointer;">
            <svg t="1629886696044" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8279" data-spm-anchor-id="a313x.7781069.0.i33" width="64" height="64"><path d="M521.380648 134.212748c-202.51332 0-366.682333 143.078673-366.682333 319.574433s164.16799 319.574433 366.682333 319.574433c33.242102 0 65.291029-4.199649 95.90835-11.425214l133.268236 80.178087L750.557234 703.034894c83.755566-58.569954 137.505747-148.379399 137.505747-249.247714C888.062981 277.290397 723.893968 134.212748 521.380648 134.212748zM538.464745 636.900661l-53.131081 0 0-53.116755 53.131081 0L538.464745 636.900661zM631.925347 378.182248c-1.671059 7.609305-4.595668 15.129582-8.772804 22.559808-4.178159 7.430226-9.862625 15.039531-17.039072 22.798239-7.191796 7.758708-16.129352 16.322757-26.811646 25.693172-10.862395 9.191336-19.381419 16.830317-25.558096 22.917966-6.176676 6.117324-10.81737 12.294001-13.905708 18.531052-3.088338 6.266727-5.013177 13.427824-5.759167 21.425985-0.76134 8.026814-1.133823 18.4717-1.133823 31.332612l-45.596478 0c0-16.023952 0.74599-29.244045 2.25332-39.59888s4.088108-19.605523 7.773034-27.811416c3.670599-8.176217 8.847505-16.054651 15.531741-23.663956 6.66991-7.609305 15.277962-16.591887 25.811876-26.945699 7.341199-7.16212 13.935384-13.279445 19.784602-18.292622 5.684466-5.013177 10.443863-9.906627 14.279215-14.651698 3.849678-4.774747 6.729262-9.906627 8.654101-15.397688 1.909489-5.520737 2.879584-12.294001 2.879584-20.321838 0-9.847276-1.805112-18.948561-5.386684-27.303856-3.595898-8.355295-8.56405-15.576767-14.905478-21.664416-6.355755-6.087649-13.876032-10.862395-22.559808-14.293541-8.683776-3.40147-18.202571-5.132904-28.557406-5.132904-41.269939 0-65.739237 23.902386-73.423243 71.677483l-50.102095 0c1.163499-16.561188 4.968152-31.571043 11.399631-45.118594 6.430456-13.517875 15.025205-25.095561 25.797549-34.704406 10.787694-9.608845 23.439852-17.039072 37.971823-22.290679 14.531971-5.251607 30.393217-7.90811 47.596018-7.90811 18.710131 0 35.585473 2.65548 50.625004 7.90811 15.025205 5.251607 27.841092 12.473079 38.465057 21.664416 10.593266 9.191336 18.784832 20.082384 24.543999 32.704866 5.774517 12.622482 8.654101 26.349111 8.654101 41.209564C634.431423 362.366028 633.581056 370.602619 631.925347 378.182248z" p-id="8280" fill="#1296db"></path></svg>
            <span style="line-height:60px;">&nbsp;&nbsp;材料填报须知</span>
          </el-col>
          <el-col :span="4" style="display: flex;justify-content: center;align-items:center;cursor:pointer;" >
            <img src="./image/nameplate_icon.png" style="width:60px;"/>
            <span style="line-height:60px;" @click="nameplateHandler">&nbsp;&nbsp;电子铭牌</span>
          </el-col>
        </el-row>
        <!--材料列表-->
        <div class="app-container calendar-list-container" v-if="dataLoadingEnd">
            <div class="filter-container">
                <el-table
                        v-loading="loading"
                        :data="tableData"
                        border
                        style="width:100%;margin:0 0 50px;" header-row-class-name="weightHeader">
                  <el-table-column
                          type="index"
                          label="序号"
                          width="60"
                          align="center"

                  >
                  </el-table-column>
                  <el-table-column
                          prop="materialName"
                          label="材料名称"
                          width="320"
                  >
                    <template slot-scope="scope">{{scope.row.materialName}}<br/><a href="javascript:void(0)" @click="downloadFile(scope.row.templateFile)" v-if="scope.row.templateFile">下载模板</a></template>
                  </el-table-column>
                  <el-table-column
                      prop="materialName"
                      label="已上传材料名"
                      width="260"
                  >
                    <template slot-scope="scope"><a href="javascript:void(0)" @click="downloadFile(scope.row.filePath)" v-if="scope.row.filePath">{{scope.row.fileName}}</a></template>
                  </el-table-column>
                  <el-table-column
                          prop="formType"
                          width="240" align="left" :render-header="uploadLabel">
                    <template slot-scope="scope">
                      <span v-if="!scope.row.status || scope.row.status==2">
                        <upload-component v-on:on-upload="(e)=>uploadHandler(scope.row, e)" v-if="scope.row.materialType==0 || scope.row.materialType==2"
                          :fileSerial="scope.row.filePath">
                          <!--<template v-slot:default><span style="font-size:10px">支持PDF,Word,图片等格式</span> </template>-->
                        </upload-component>
                        <el-button type="success" @click="inputForm(scope.row)" v-if="scope.row.materialType==1 || scope.row.materialType==2" size="small">{{scope.row.isInput==1?'已录入':'录入'}}</el-button>
                      </span>
                      <span v-else>已提交</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop=""
                      label="审核结果">
                    <template slot-scope="scope">
                      {{status(scope.row.status)}}
                      <span v-if="scope.row.status==2">,驳回理由：{{scope.row.auditContent}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="feedbackContent"
                          label="收到反馈">
                  </el-table-column>
                </el-table>
            </div>
        
          </div>
          <div v-else style="padding:20px;"><el-empty description="数据加载中"></el-empty></div>
      </el-col>
      <el-col :span="2"><div class="grid-content bg-purple-light">&nbsp;</div></el-col>
    </el-row>


    <el-dialog width="1024px" :title="'表单录入'" :visible.sync="dialogFormVisible" v-if="dialogFormVisible">
      <form-view @close="close()" @success="formSuccess" :formId="currentRow.formId" :formType="formType" :prop="userStatus" :key="formType"></form-view>
    </el-dialog>

    <el-dialog width="740px" :title="'企业电子铭牌'" :visible.sync="nameplateShow" v-show="nameplateShow">
      <canvas  ref="nameplateCanvas" id="nameplateCanvas"></canvas>
    </el-dialog>
  </d2-container>
</template>

<script>
import { mapState } from 'vuex'

import { addObj } from '@/api/admin/sysEnterpriseMaterial/index';
import uploadComponent from '../admin/common/upload-com.vue'
import {getList} from "../../api/admin/sysEnterpriseMaterial";
import {download} from "../../api/admin/sysFiles";
import FormView from "../admin/sysForm/";
import {queryStatus} from "../../api/admin/sysEnterprise/index";
import GovWorkbench from "./gov";
import nameplateBg from './image/nameplate_bg.png';
export default {
  components:{
      GovWorkbench,
      uploadComponent,
      FormView
  },
  computed:{
    ...mapState('d2admin/releases', [
      'version'
    ])
  },
  data(){
      return {
          loading: true,
          dataLoadingEnd: false,
          tableData: [],
          dialogFormVisible:false,
          nameplateShow:false,
          formType: null,
          currentRow:null,
          userStatus:{
              "preview":true,
              "entType":null,
              "entStatus":null,
              "id":null,
              "username":"",
              "name":"",
              "entId":null,
              "departmentId":null,
              "auth":false,
              "record": false,
              "totalMaterial": 0,
              "subMaterial": 0,
              "oilEdequipmentCode": "",
              "workAddress": "",
              "entName": "",
          }
      }
  },
  created(){
     this.init();
  },
  computed:{
     "materialFinish":function(){
         return (this.userStatus.totalMaterial-this.userStatus.subMaterial)==0;
     }
  },
  methods:{
      uploadLabel:function(h,  { column, $index }){
//          innerHTML: '填报（附件格式只支持PDF,Word,图片等格式）<br/><i class="el-icon-info" @click=""></i>'
//          el-tooltip placement="top">
//              <div slot="content">多行信息<br/>第二行信息</div>
//              <el-button>Top center</el-button>
//          </el-tooltip>
          return h("span",{
              attrs:{class:"weightHeader"}
          },[
              h("span","填报（附件支持PDF,Word,图片等格式）"),
              h("el-tooltip",{props:{"placement":"top"}},[
                  h("div",{slot:"content"},"点击跳转到在线PDF转换平台进行压缩？"),
                  h("span",{on:{
                      click:function(){
                          window.open("https://smallpdf.com/cn/compress-pdf",'在线压缩平台')
                      }
                  },domProps:{innerHTML:"<div style='cursor:pointer;'><i class='el-icon-info'  style='color:red;'></i><span style='color:red;'>PDF文件太大，上传失败？</span></div>"}})
              ]),

          ]);
      },
      status(status){
        if(status==0){return "等待提交"}
        else if(status==1){return "待审核"}
        else if(status==2){return "驳回"}
        else if(status==3){return "审核通过"}
        return "";
      },
      uploadHandler:function(row, file){
        row.fileName=file.fileName;
        row.filePath=file.fileSerial;
        this.saveEntMaterial({...row, isInput: 0});
      },
      formSuccess:function(response){
          console.log(decodeURIComponent(response.content))
          this.currentRow.formId=response.formId;
          this.currentRow.formHtml=response.content || "";
          this.currentRow.fileName=null;
          this.currentRow.filePath=null;
          this.saveEntMaterial({...this.currentRow, isInput:1});
          this.close();
      },
      init:function(){
        getList({}).then(response=>{
          console.log(response);
          this.tableData = response.map(x=>{
            x.filePath=x.filePath || "";
            x.fileName=x.fileName || "";
            return x; 
          });
          this.loading =false;
        }).finally(x=>{
          this.dataLoadingEnd = true;
        });
        queryStatus({}).then(response=>{
            this.userStatus = response;
            this.loading =false;
        })
      },
      saveEntMaterial(row){
        addObj(Object.assign(row, {status:1})).then(response=>{
          this.init();
          this.$notify({
            title: '成功',
            message: '材料上传成功',
            type: 'success',
            duration: 2000
          });
        })
      },
      inputForm(row){
          console.log("当前表单",JSON.stringify(row))
          this.dialogFormVisible = true;
          this.formType = row.formType;
          this.currentRow = row;
      },
      nameplateHandler(){
          this.nameplateShow = true;
          this.$nextTick(()=>{
              let canvas = document.getElementById("nameplateCanvas");
              let cxt = canvas.getContext('2d');
              canvas.width = 700;
              canvas.height = 420;
              let img = new Image();
              img.src =  nameplateBg;
    //          // 图片加载完成，才可处理
              img.onload = () => {
                  // 画图(这里画布与图片等宽高)
                  cxt.drawImage(img, 0, 0, 700, 420);
                  // 设置字体大小
                  cxt.font = " bold 43px Microsoft YaHei";
                  // 更改字号后，必须重置对齐方式，否则居中麻烦。设置文本的垂直对齐方式
                  cxt.textBaseline = 'middle';
                  cxt.textAlign = 'center';
                   // 距离左边的位置
                  var left = canvas.width / 2;
                  // 距离上边的位置 (图片高-文字距离图片底部的距离)
                  var top = canvas.height - 328;
                  // 文字颜色
                  cxt.fillStyle = "#B71D25";
                  // 文字在画布的位置
                  cxt.fillText(this.userStatus.entName, left, top+=10);
                  cxt.fillStyle = "#310706";
                  cxt.font = " bold 32px Microsoft YaHei";

                  cxt.fillText("备案编号："+(this.userStatus.filingNo || ""), left, top+120);

                  cxt.font = " 18px Microsoft YaHei";
                  cxt.fillText("撬装编号："+(this.userStatus.oilEdequipmentCode || ""), left, top+200);

                  cxt.font = " 18px Microsoft YaHei";
                  cxt.fillText("撬装设立地址："+(this.userStatus.workAddress || ""), left, top+240);
              }
          })
      },
      downloadFile(id){
          download(
id);
      },
      close(flush){
        this.dialogFormVisible=false;
        this.nameplateShow=false;
        this.currentRow=null;
      },
  }
}
</script>
<style>
  .upload-demo{display:inline-block;margin-right:4px;}
  a{color:red;cursor: pointer}
  .boldFont{font-weight: bold;color:red;}
  a{color:red;cursor: pointer}
  #page .d2-container-full__body {
    padding: 0px;
  }
  .weightHeader{
    font-size: 15px;
    color: #575858;
    font-weight: bold;}
</style>
